import { Component, OnInit, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Haptics } from '@capacitor/haptics';
import { ViewDidLeave } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { IFarmModel } from 'src/app/core/models/interfaces/farm-model';
import { IGeoJSONObj } from 'src/app/core/models/interfaces/map-fn-props';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LocationService } from 'src/app/core/services/location.service';
import { MapService } from 'src/app/core/services/map.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';
import { AddImportFarmComponent } from './components/add-import-farm/add-import-farm.component';
import { AddScoutingInfoModalComponent } from './components/add-scouting-info-modal/add-scouting-info-modal.component';
import { AddScoutingNoteModalComponent } from './components/add-scouting-note-modal/add-scouting-note-modal.component';
import { MapFilterComponent } from './components/map-filter/map-filter.component';
import { FarmMapResponse } from './models/farm-map.model';
import { FarmMapService } from './services/farm-map.service';
import { PermissionService } from 'src/app/core/services/permission.service';

type PageType = "scoutingNotes" | "unknown";

@Component({
  selector: 'app-farm-map',
  templateUrl: './farm-map.page.html',
  styleUrls: ['./farm-map.page.scss'],
})

export class FarmMapPage implements OnInit, ViewDidLeave {
  @ViewChild("currentPageComponent") currentPageComponent

  farmList: FarmMapResponse[] = [];
  map;
  mapCenter: { lat, lng } = null;
  openTimeline: boolean = false;
  openTimelineSettimeout: boolean = false;
  selectedFarm: IFarmModel;
  filterFarmList: FarmMapResponse[] = [];
  selectedFilterItem: any;
  mapFarmList: Array<any> = [];
  farm: any;
  markerList: Array<any> = [];
  farmMarkerList: Array<any> = [];
  addNoteShow: boolean = false;
  type: string = "filiz";
  selectedInfoFarm: any;
  currentPage: PageType = "unknown";
  scoutingId
  constructor(
    private loadingService: LoadingService,
    private farmMapService: FarmMapService,
    private modalService: ModalService,
    private mapService: MapService,
    private locationService: LocationService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private storageService: StorageService) {

  }
  ionViewDidLeave(): void {
  }
  resizeMap() {
    if (this.map) {
      this.mapService.resizeMap(this.map);
    }
  }
  ionViewWillEnter() {
    this.resizeMap();
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e.IsSuccess) {
        this.type = e.Data ? "filiz" : "trap";
      }
    });
    // this.getLocation();
    this.storageService.get(StorageKeys.FIRST_LOGIN).then(e => {
      if (e.IsSuccess) {
        if (e.Data) {
          this.modalService.presentModal({
            component: AddScoutingInfoModalComponent,
            componentProps: {},
            options: ModalService.defaultOptionsTransparent
          }).then(res => {
          }).catch(err => {
          })
          this.addNoteShow = true;
        } else {
          this.addNoteShow = false;
        }
      }
    });
    this.storageService.get(StorageKeys.mapUpdated).then(e => {
      if (e.IsSuccess) {
        if (e.Data) {
          this.removeLayer();
          this.clearfarmMarkerList();
          this.clearFarmFlagMarkers();
          this.getFarmList().subscribe(e => {
            this.loadingService.hideLoading();
            if (e) {
              this.setFarmFieldPolygon(true);
            }
          });
          this.storageService.set(StorageKeys.mapUpdated, false);
        }
      }
    });
  }


  ngOnInit() {
  }

  openPreview() {
    setTimeout(() => {
      this.openTimelineSettimeout = true;
    }, 1500);
  }

  mapLoaded(ev) {
    this.map = ev;
    setTimeout(() => {
      this.getFarmList().subscribe(e => {
        this.loadingService.hideLoading();
        if (e) {
          this.setFarmFieldPolygon(true);
        }
      });
    }, 1);
    this.storageService.get(StorageKeys.FIRST_LOGIN).then(e => {
      if (e.IsSuccess) {
        if (e.Data) {
          PermissionService.CheckAndRequestLocation({
            granted: () => {
              this.mapService.followMyLocation({ map: this.map, icon: null, id: "home-map-me" })
            }, rejected: () => {
              PermissionService.instanceOfService.permissionDeniedAlert("location")
            }
          });
          this.storageService.set(StorageKeys.FIRST_LOGIN, false).then();
        }
      }
    });

  }
  setFarmFieldPolygon(isReload: boolean) {
    this.removeLayer();
    this.clearfarmMarkerList();
    this.clearFarmFlagMarkers();
    this.mapFarmList = [];
    this.selectedFilterItem = null;
    this.setGeoList(this.farmList, isReload);
    this.setMarker(this.farmList);
    this.setFarmMarker(this.farmList);
  }

  setMarker(list: FarmMapResponse[]) {
    let markerList = [];
    list.forEach(element => {
      if (element.ScoutingIdList && element.ScoutingIdList.length > 0) {
        markerList.push(...element.ScoutingIdList.map(e => {
          return {
            "type": "Feature",
            "geometry": JSON.parse(e.ScoutingGeoJson).geometry,
            "properties": {
              id: e.Id,
              color: "#F1FF9B",
              markerClassName: `marker`,
              anchor: "bottom"
            }
          } as IGeoJSONObj
        }));
      }

    });
    this.markerList = this.mapService.addMarkersArray({
      map: this.map,
      flagsGeojson: markerList,
      callback: this.flagMarkerCallback,
      type: this.type
    })
  }

  setFarmMarker(list: FarmMapResponse[]) {
    let type = this.type;
    let markers = [];
    let className = "map-marker";
    let existAllDevice: boolean = false;
    list.forEach(e => {
      let image = environment.imageUrl;
      if (e.IsFiliz && e.IsPestTrap) {
        type = this.type;
        existAllDevice = true;
        className = "map-marker-two-device"
        image = image + "map-filiz-trap.svg";
      } else if (e.IsFiliz && !e.IsPestTrap) {
        type = "filiz";
        existAllDevice = false;
        image = image + "map-filiz.svg";
        className = "map-marker";
      } else if (!e.IsFiliz && e.IsPestTrap) {
        className = "map-marker";
        type = "trap";
        existAllDevice = false;
        image = image + "map-trap.svg";
      }
      markers.push({
        geojson: JSON.parse(e.GeoJson),
        className: className,
        farmId: e.TempFarmAttId,
        type: type,
        image: image,
        existAllDevice: existAllDevice
      });
    });
    this.farmMarkerList = this.mapService.addArrMarkerWithImage(this.map, markers, this.farmMarkerClick);

  }

  farmMarkerClick = (ev, type, existAllDevice, latlng) => {
    this.selectedInfoFarm = null;
    this.selectedFarm = null;
    setTimeout(() => {
      this.selectedInfoFarm = { id: ev, type: type, existAllDevice: existAllDevice };
    }, 1);
    this.mapService.flyTo(this.map, { lat: latlng[1], lng: latlng[0] }, 14).subscribe()
  }

  flagMarkerCallback = (ev) => {
    this.currentPage = "scoutingNotes"
    this.farmList.forEach(e => {
      if (e.IsScoutingNote) {
        e.ScoutingIdList.forEach(elem => {
          if (elem.Id == ev) {
            this.farm = e;
            this.scoutingId = ev;
            let coordinates = JSON.parse(elem.ScoutingGeoJson).geometry.coordinates
            this.mapService.flyTo(this.map, { lat: coordinates[1], lng: coordinates[0] }, 14).subscribe()
          }
        })
      }
    })
  }

  clearfarmMarkerList() {
    this.farmMarkerList.forEach(el => {
      var doc = document.getElementById('marker-' + el.farmId)
      if (doc) {
        doc.remove();
      }
      el.marker.remove();
    })
    this.farmMarkerList = [];
  }

  clearFarmFlagMarkers() {
    this.markerList.forEach(el => {
      var doc = document.getElementById('marker-' + el.id)
      if (doc) {
        doc.removeEventListener('click', this.flagMarkerCallback)
      }
      el.marker.remove()
    })
    this.markerList = [];
  }

  refreshFlagMarkers() {
    this.clearFarmFlagMarkers();
    this.setFarmFieldPolygon(true);
  }

  getLocation(goLocation: boolean = false) {
    this.loadingService.showLoading();
    let devicePlatform = Capacitor.getPlatform();
    LocationService.GetMyCurrentLocation().then(response => {
      this.loadingService.hideLoading();
      if (response.IsSuccess && response.Data) {
        this.mapCenter = { lat: response.Data.latitude, lng: response.Data.longitude }
        if (goLocation)
          this.setLocation(this.mapCenter.lat, this.mapCenter.lng);
        this.mapService.followMyLocation({ map: this.map, icon: null, id: "home-map-me" })
      }
    }).catch(err => {
      this.loadingService.hideLoading();
      PermissionService.instanceOfService.permissionDeniedAlert("location");
    })
  }

  setLocation(lat, lng) {
    if (this.map)
      this.mapService.flyToLocation({ map: this.map, latitude: lat, longitude: lng, scope: this });
  }

  getFarmList(): Observable<boolean> {
    return new Observable(observer => {
      this.loadingService.showLoading();
      this.farmMapService.getFarmList().subscribe(res => {
        this.loadingService.hideLoading();
        if (res.IsSuccess) {
          this.farmList = res.Data;
          observer.next(true);
        } else {
          observer.next(false);
        }
      });
    });
  }

  clickFarm(farm) {
    this.selectedFarm = farm;
  }

  removeLayer() {
    if (this.selectedFarm) {
      this.mapService.removeLayer({ map: this.map, scope: this, id: "border" });
      this.selectedFarm = null;
    }
    this.mapFarmList.forEach(farm => {
      this.mapService.removeLayer({ map: this.map, scope: this, id: farm });
      this.mapService.removeLayer({ map: this.map, scope: this, id: farm + "_outline" });
      this.mapService.removeSource({ map: this.map, scope: this, id: farm });
    });
  }

  setBorderSelectedFarm(e) {
    if (this.selectedFarm) {
      this.mapService.removeLayer({ map: this.map, scope: this, id: "border" });
    }
    this.selectedFarm = e.farm;
    this.mapService.addBorder({ map: this.map, scope: this, polygonId: this.selectedFarm.TempFarmAttId.toString() });
    this.farm = this.selectedFarm.TempFarmAttId;
    this.mapService.fitBounds({ map: this.map, geojson: e.geojson, padding: 25 })
  }

  setGeoList(list: FarmMapResponse[], isReload: boolean = true, fillColor: string = "#fff") {
    this.loadingService.showLoading();
    let geoList = [];
    geoList.push(
      ...list.map((val, index, arr) => {
        return {
          geojson: JSON.parse(val.GeoJson),
          farm: val,
          fillColor: fillColor
        };
      })
    );
    let centerList = [];
    geoList.forEach(e => {
      this.mapService.addPolygonToMap({
        map: this.map, scope: this, geojson: e.geojson, longPressCallback: this.selectedFarmLongpressEvent, polygonId: e.farm.TempFarmAttId.toString(), addClickEvent: true, item: e,
        callback: (f => {
          this.setBorderSelectedFarm(e);
        })
      });
      this.mapFarmList.push(e.farm.TempFarmAttId.toString());
      try {
        if (e.geojson.geometry && e.geojson.geometry.type == "Polygon") {
          let bound = this.mapService.getBounds(e.geojson)
          centerList.push(bound.getSouthWest());
          centerList.push(bound.getNorthEast());
          centerList.push(bound.getNorthWest());
          centerList.push(bound.getSouthEast());
        }
      } catch (error) {
      }
    });
    if (isReload)
      // setTimeout(() => {
      this.mapService.fitAllFarmBounds(centerList, this.map);
    // }, 500);

    this.loadingService.hideLoading();
  }


  callTimes = 0;
  isModalOpened = 0
  selectedFarmLongpressEvent = (ev) => {
    let farm;
    if (ev.features) {
      let faeture = this.map.queryRenderedFeatures(ev.point, { layers: [ev?.features[0]?.layer.id] });
      farm = this.farmList.find(e => { return e.TempFarmAttId == +faeture[0].layer.id });
    }
    let that = this
    let intervalName = null;
    let passedTime = null;
    var latestEvent = ev.type
    let actionFns = {
      "touchstart": (ev) => {
        this.callTimes++
        intervalName = this.callTimes + "_interval"
        passedTime = this.callTimes + "_passed"
        that[passedTime] = 0;
        that[intervalName] = setInterval(() => {
          that[passedTime] = that[passedTime] + 1;
          if (that[passedTime] >= 3) {
            if (latestEvent !== 'touchstart') {
              that[passedTime] = 0;
              clearInterval(that[intervalName]);
            } else {
              Haptics.vibrate({ duration: 300 }).then(res => { });
              if (this.isModalOpened === 0)
                that.openAddScoutNoteModal(ev.lngLat, farm)
              that[passedTime] = 0;
              clearInterval(that[intervalName]);
            }
          }
        }, 500);
      },
      "touchend": (ev) => {
        intervalName = this.callTimes + "_interval"
        passedTime = this.callTimes + "_passed"
        that[passedTime] = 0;
        clearInterval(that[intervalName]);
        if (this.callTimes > 0)
          this.callTimes--
      },
      "zoom": (ev) => {
        intervalName = this.callTimes + "_interval"
        passedTime = this.callTimes + "_passed"
        that[passedTime] = 0;
        clearInterval(that[intervalName]);
        if (this.callTimes > 0)
          this.callTimes--
      },
      "move": (ev) => {
        intervalName = this.callTimes + "_interval"
        passedTime = this.callTimes + "_passed"
        that[passedTime] = 0;
        clearInterval(that[intervalName]);
        if (this.callTimes > 0)
          this.callTimes--
      }
    }
    actionFns[ev.type](ev)
  }


  openAddScoutNoteModal({ lat, lng }, farm) {
    this.isModalOpened++
    this.modalService.presentModal({
      component: AddScoutingNoteModalComponent,
      componentProps: { flagCoordinates: { lat, lng }, currentFarm: farm },
      options: ModalService.fullPageOptions
    }).then(response => {
      this.isModalOpened--
      response.modalObj.onDidDismiss().then(dismiss => {
        if (dismiss && dismiss.role === "saved") {
          this.map.resize();
          this.getFarmList().subscribe(e => {
            this.loadingService.hideLoading();
            if (e) {
              this.setFarmFieldPolygon(false);
            }
          });
        }
      })
    })
  }

  setFilter() {
    this.clearFarmFlagMarkers();
    this.clearfarmMarkerList();
    this.removeLayer();
    this.mapFarmList = [];
    this.filterFarmList = this.farmList.filter(farm => farm[this.selectedFilterItem.Id]);
    if (this.filterFarmList.length == 0) {
      this.loadingService.hideLoading()
      this.toastService.PresentBasicToast({
        message: this.translateService.instant("farm-map.no-filter-array"),
        duration: 3500,
        type: Message_Type.PRIMARY
      })
    } else {
      this.setGeoList(this.filterFarmList, true, this.selectedFilterItem.color);
      this.setMarker(this.filterFarmList);
      this.setFarmMarker(this.filterFarmList);
    }

  }

  openAddField() {
    this.modalService.presentModal({
      component: AddImportFarmComponent,
      componentProps: {
      },
      options: ModalService.defaultOptionsTransparent
    }).then(e => {
      e.modalObj.onDidDismiss().then(res => {
        if (res.role == "") {

        }
      });
    });
  }

  openFilterModal() {

    this.modalService.presentModal({
      component: MapFilterComponent,
      componentProps: {
        selected: this.selectedFilterItem?.Id
      },
      options: ModalService.defaultOptionsTransparent
    }).then(e => {
      e.modalObj.onDidDismiss().then(res => {
        if (res.role == "map-filter") {
          if (this.selectedFarm) {
            this.mapService.removeLayer({ map: this.map, scope: this, id: "border" });
            this.selectedFarm = null;
          }
          this.selectedFilterItem = res.data;
          this.setFilter();
        }
      });
    });
  }

  openInfo() {
    this.modalService.presentModal({
      component: AddScoutingInfoModalComponent,
      componentProps: {},
      options: ModalService.defaultOptionsTransparent
    }).then(res => {
    }).catch(err => {
    })
  }

  BackAction(ev, prop) {
    this.currentPage = 'unknown'
    switch (prop) {
      case "scoutingNotes":
        if (ev.action == 'delete') {
          let tempItem = this.markerList.find(t => t.id === ev.value)
          tempItem.marker.remove()
          this.markerList = this.markerList.filter(t => t.id !== ev.value)
        }
        if (ev.action == 'edit') {
          //devam edilecek
          this.clearFarmFlagMarkers();
          this.getFarmList().subscribe(e => {
            this.loadingService.hideLoading();
            if (e) {
              this.setFarmFieldPolygon(false);
            }
          });
        }
        break;

      default:
        break;
    }
  }

  CloseImagery() {
    this.clearFarmFlagMarkers();
    this.getFarmList().subscribe(e => {
      this.loadingService.hideLoading();
      if (e) {
        this.setFarmFieldPolygon(false);
        this.currentPage = null;
      }
    });
  }
}
